enum DataLayerActionType {
  CLICK = 'click',
  SEARCH = 'search',
}

export default DataLayerActionType;
